import { jsxs as h, Fragment as T, jsx as a } from "react/jsx-runtime";
import { useFloating as U, autoPlacement as G, flip as K, shift as L, offset as V, arrow as q, autoUpdate as z, useFocus as J, useHover as Q, safePolygon as X, useClick as Y, useDismiss as Z, useRole as ee, useInteractions as te, FloatingPortal as oe, FloatingArrow as se } from "@floating-ui/react";
import ne from "clsx";
import { useState as le, useEffect as re, useRef as ie } from "react";
const v = (i) => ne(i), fe = "#00040f", ae = "#ffffff", R = "#14161f", t = "dds-popover-v0112", C = 8, ce = 16, $ = 1;
function ge({
  children: i,
  className: c = "",
  textAlignment: d = "center",
  additionalOffset: D = 0,
  placement: E = "top",
  autoPlace: s = !1,
  hasTail: n = !0,
  background: e = "dark",
  content: F,
  id: p,
  defaultVisible: w = !1,
  open: l,
  onOpenChange: x,
  allowPinning: y = !0,
  onOpen: f,
  ...A
}) {
  const [I, S] = le(w), r = l ?? I, W = x ?? S;
  re(() => {
    r && f && f();
  }, [r, f]);
  const u = ie(null);
  let m = 0;
  n && (m = C + (e === "light" ? $ * 2 : 0));
  const { refs: g, floatingStyles: k, context: o } = U({
    placement: s ? void 0 : E,
    whileElementsMounted: z,
    middleware: [
      s && G(),
      !s && K(),
      !s && L({ padding: 8 }),
      V(m + D),
      n && q({ element: u })
    ],
    open: r,
    onOpenChange: W
  }), H = J(o, { enabled: l == null }), O = Q(o, {
    enabled: l == null,
    handleClose: X({ blockPointerEvents: !0 }),
    delay: 100
  }), P = Y(o, {
    toggle: !1,
    enabled: l == null,
    ignoreMouse: !y
  }), _ = Z(o), b = ee(o, { role: "tooltip" }), { getReferenceProps: B, getFloatingProps: M } = te([
    H,
    O,
    P,
    _,
    b
  ]), N = {
    [t]: !0,
    [`${t}--background-${e}`]: e === "dark",
    [`${t}--no-tail`]: !n,
    [c]: c.length > 0
  }, j = {
    [`${t}--popover`]: !0,
    [`${t}--popover-text-${d}`]: d === "left-align",
    [`${t}--popover-background-${e}`]: e === "dark"
  };
  return /* @__PURE__ */ h(T, { children: [
    /* @__PURE__ */ a(
      "div",
      {
        tabIndex: -1,
        className: v(N),
        "aria-describedby": p,
        ref: g.setReference,
        ...A,
        ...B(),
        children: i
      }
    ),
    r && /* @__PURE__ */ a(oe, { children: /* @__PURE__ */ h(
      "div",
      {
        role: "tooltip",
        id: p,
        "aria-hidden": "false",
        className: v(j),
        ref: g.setFloating,
        style: k,
        ...M(),
        children: [
          F,
          n && /* @__PURE__ */ a(
            se,
            {
              className: `${t}--tail`,
              ref: u,
              context: o,
              stroke: e === "light" ? `${fe}15` : R,
              fill: e === "light" ? ae : R,
              strokeWidth: e === "light" ? $ : 0,
              height: C,
              width: ce
            }
          )
        ]
      }
    ) })
  ] });
}
export {
  ge as Popover
};
//# sourceMappingURL=index.js.map
